import DashboardStore from "../DashboardStore";
import React, { FC, useEffect, useState } from "react";
import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import NewOrderIcon from "../../../../../../images/common/cart-blue.svg";
import {  DashboardService } from "../../../shared/services";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  Loader,
  SapphireBlueButton,
  ToastService,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import { NewOrdersModel } from "../../../shared/models";
import { AccountSettingsStore } from "../../../shared/store";

type IProps = {
  dashboardStore: DashboardStore;
  merchantAccountId: string;
};
const NewOrdersWidget: FC<IProps> = ({ dashboardStore, merchantAccountId }) => {
  const [showLoader, setLoader] = useState(false);
  useEffect(() => {
    if (!merchantAccountId) return;
    setLoader(true);
    DashboardService.getNewOrders(
      AuthService.authData.accountId,
      merchantAccountId
    ).subscribe({
      next: (response) => {
        setLoader(false);
        const mappedData = NewOrdersModel.deserializeAPIModel(response.result);
        dashboardStore.updateNewOrders(mappedData);
      },
      error: () => {
        ToastService.showError("Error Occured");
      },
    });
  }, [merchantAccountId]);

  if (showLoader || !dashboardStore.newOrdersWidgetData)
    return <>{new Loader(true).loaderComponent}</>;

  const amount =
    "$" +
    AccountSettingsStore.formatAmount(
      dashboardStore.newOrdersWidgetData.newOrdersAmount
    );
  return (
    <>
      <FlexContainer
        justifyContent="space-between"
        className="activity-header-wrapper"
      >
        <div>
          <FlexContainer
            alignItems="center"
            spacing={10}
            padding="0px 0px 30px"
          >
            <img src={NewOrderIcon} />
            <div className="activity-card-header">New Orders</div>
          </FlexContainer>
        </div>
        <div>
          <SapphireBlueButton>View</SapphireBlueButton>
        </div>
      </FlexContainer>
      <div className="subscriptions-graph">
        <FlexContainer
          justifyContent="space-between"
          alignItems="center"
          padding="0px 0px 25px"
          className="graph-sub-header"
        >
          <div>
            <FlexContainer fxLayout="column" alignItems="center" spacing={15}>
              <CustomLabel>New Orders</CustomLabel>
              <CustomLabel>
                ${AccountSettingsStore.formatAmount(parseFloat(amount) || 0)}
              </CustomLabel>
            </FlexContainer>
          </div>
          <div>
            <FlexContainer fxLayout="column" alignItems="center" spacing={15}>
              <CustomLabel>No Orders</CustomLabel>
              <CustomLabel>
                {UtilityMethods.numberWithCommas(
                  dashboardStore.newOrdersWidgetData.total
                )}
              </CustomLabel>
            </FlexContainer>
          </div>
          <div>
            <FlexContainer fxLayout="column" alignItems="center" spacing={15}>
              <CustomLabel>Last Order</CustomLabel>
              <CustomLabel>
                {dashboardStore.newOrdersWidgetData.lastOrder
                  ? UtilityMethods.formatDateInString(
                      dashboardStore.newOrdersWidgetData.lastOrder
                    )
                  : "-"}
              </CustomLabel>
            </FlexContainer>
          </div>
        </FlexContainer>
        <CustomLabel fontSize={"14px"}>New Orders</CustomLabel>
        <ResponsiveContainer height={200}>
          <AreaChart
            data={dashboardStore.newOrdersWidgetData.graphData}
            width={600}
            height={200}
          >
            <XAxis
              width={30}
              dataKey="label"
              tickLine={false}
              axisLine={false}
            />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="total"
              stroke="#8884d8"
              fill="#8884d8"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default NewOrdersWidget;
